export const primaryLinks = [
  {
    id: 'shipping-estimate-header-link',
    title: 'Shipping Estimate',
    link: ''
  },
  {
    id: 'tracking-header-link',
    title: 'Tracking',
    link: ''
  },
  {
    id: 'search-header-link',
    title: 'Search',
    link: ''
  },
]

export const whereToShopMenu = [
  {
    id: 'shop-in-AU-header-link',
    title: 'Australia',
    url: '/shop-in-au?utm_source=web&utm_medium=deals&utm_campaign=ph-web-deals-australia-launch-20210309'
  },
  {
    id: 'shop-in-KR-header-link',
    title: 'Korea',
    url: '/shop-in-kr?utm_source=website&utm_medium=header&utm_campaign=ph-web-tab-korea-shopping-20210922'
  },
  {
    id: 'shop-in-JP-header-link',
    title: 'Japan',
    url: '/shop-in-jp?utm_source=web&utm_medium=banner&utm_campaign=shop-in-japan20210120'
  },
  {
    id: 'shop-in-UK-header-link',
    title: 'United Kingdom',
    url: '/shop-in-uk'
  },
  {
    id: 'shop-in-US-header-link',
    title: 'United States',
    url: '/shop-in-us'
  }
]

export const servicesMenu = [
  {
    id: "buy-for-me-header-link",
    title: "Buy-For-Me",
    url: "/buy-for-me-shopping-guide",
  },
  {
    id: "sc-protect-header-link",
    title: "SC Protect",
    url: "/sc-protect",
  },
  {
    id: "social-seller-header-link",
    title: "Social Seller",
    url: "/shippingcart-sellers",
  },
  {
    id: "chrome-extension-header-link",
    title: "Chrome Extension",
    url: "https://chrome.google.com/webstore/detail/shippingcart-shop-assist/comhbeibpkdfofkamlfoacboohagncbk?hl=en",
    external: true,
  },
];

export const offersMenu = ({accountNumber, firstName}) => [
  {
    id: 'promos-header-link',
    title: 'Promos',
    url: '/promotions'
  },
  {
    id: 'rewards-header-link',
    title: 'Rewards',
    url: accountNumber ? `https://rewards.shippingcart.com?account_number=${accountNumber}&name=${firstName}` : `https://rewards.shippingcart.com/` ,
    external: true
  },
  {
    id: 'referral-header-link',
    title: 'Referral',
    url: '/referral',
  },
]

export const helpCenterMenu = [
  {
    id: 'about-us-header-link',
    title: 'About Us',
    url: '/about-us'
  },
  {
    id: 'how-it-works-header-link',
    title: 'How it works',
    url: '/how-it-works',
  },
  {
    id: 'faqs-header-link',
    title: 'FAQ',
    url: 'https://help-center.shippingcart.com/hc/en-us',
    external: true
  },
  {
    id: 'special-handling-header-link',
    title: 'Special Handling',
    url: '/special-handling'
  },
  {
    id: 'prohibited-item-header-link',
    title: 'Prohibited Items',
    url: '/prohibited-items',
  },
  
]

export const legalMenu = [
  {
    id: 'terms-and-conditions-header-link',
    title: 'Terms and Conditions',
    url: '/terms-conditions'
  },
  {
    id: 'privacy-header-link',
    title: 'Privacy Policy',
    url: '/privacy-policy',
  },
]

export const accountLinks = [
  { route: '/cart', label: 'Cart' },
  { route: '/shipment', label: 'Shipments' },
  { route: '/account', label: 'Account' },
]


/** WEBPACK FOOTER **
 ** ./src/components/Layout/constants.js
 **/